// extracted by mini-css-extract-plugin
export default {"logicSettingsHeader":"LogicSettingsHeader_logicSettingsHeader__gprYJ","text":"LogicSettingsHeader_text__1kG3P"};